import { action } from 'mobx';
import { HistoryLogService, ReceivingService } from 'common/data';
import { BaseStore } from 'core/stores';
import _ from 'lodash';

class ReceivingStore extends BaseStore {
	constructor(rootStore) {
		super(new ReceivingService(rootStore.app.baasic.apiClient));
		this.historyLogService = new HistoryLogService(rootStore.app.baasic.apiClient);
	}

	@action
	findReceiving = async filter => {
		const response = await this.service.find(filter);
		response.data.searchQuery = filter.search;
		this.response = response.data;
		return response.data;
	};

	@action async getReceiving(id, options) {
		const receiving = await this.service.get(id, options);
		this.item = receiving.data;
		return receiving.data;
	}

	@action async updateReceiving(receiving, sourceOfChange) {
		await this.service.update(receiving, sourceOfChange);
	}

	@action async createReceiving(receiving, sourceOfChange) {
		const response = await this.service.create(receiving, sourceOfChange);
		this.item = response;
		return this.item.data;
	}

	@action async deleteReceiving(receiving) {
		receiving = { id: receiving.id };
		await this.service.delete(receiving);
	}

	@action
	findReceivingHistoryLog = async filter => {
		const response = await this.historyLogService.find(filter);
		_.each(response.data.item, responseItem => {
			responseItem.changed = JSON.parse(responseItem.changed);
		});
		this.response = response.data;
	};
}

export default ReceivingStore;



// WEBPACK FOOTER //
// ./src/modules/receiving/stores/ReceivingStore.js